/**
* @file 运营中心-平台审核-司机审核
* */
<template>
  <div id="driverAudit">
    <custom-table :has-channel="mixinUserInfo.platformType == 3 ? true : false" ref="customTable"
                  has-organization="true" :customOptions="customOptions" :columns="columns" :columnsSettingShow="true">
      <template slot="customTable-top">
        <el-radio-group v-model="status" @change="statusChange" style="padding-bottom: 16px">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button :label="item.value" v-for="item in $const.SFXDRIVERAUDITSTATUS" :key="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </template>

      <template slot="search-bottom">
        <div style="margin-bottom: 16px" v-if="mixinUserInfo.platformType == 3">
          审核前，请仔细阅读车主审核要求。点击查看<span style="color: #409eff; cursor: pointer"
                                                      @click="openUrl">审核要求</span>
        </div>
      </template>

      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="128px">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" size="mini" v-if="row.applyStatus === 4" @click="viewClick(row)">查看</el-button>
            <el-button type="text" size="mini" v-if="row.applyStatus === 2" @click="passClick(row)">审核</el-button>
            <el-button type="text" size="mini" v-if="row.applyStatus === 1" @click="removeClick(row.id)"
                       style="color: red">删除
            </el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="['created', 'applyTime', 'auditTime'].includes(item.prop)">{{
            row[item.prop] | filterTime
          }}
        </template>
        <template v-else-if="item.prop === 'applyTime'">{{
            row.applyTime | filterTime
          }}
        </template>

        <template v-else-if="item.prop === 'useCharacter'">
          <el-tag v-if="row.useCharacter" :type="getUseCharacterType(row.useCharacter)" size="small">{{ row.useCharacter }}</el-tag>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'applyStatus'">
          <el-tag :type="$const.DRIVERAUDITSTATUS.find(item => item.value == row.applyStatus).type">{{
              $const.DRIVERAUDITSTATUS.find(item => item.value == row.applyStatus).label
            }}
          </el-tag>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>

    <!--查看附件弹框-->
    <el-drawer :visible.sync="visible" size="1000px" :close-on-click-modal="false" @close="cancelAudit">
      <sfxDriverAuditForm :title="auditTitle" :operationType="operationType" :auditInfo="rowData" v-if="visible"
                          @close="cancelAudit">
      </sfxDriverAuditForm>
    </el-drawer>

    <!--审核要求弹窗-->
    <el-dialog 
      title="车主审核要求" 
      :visible.sync="auditRequirementVisible" 
      width="90%" 
      top="5vh"
      :close-on-click-modal="false"
      class="audit-requirement-dialog"
    >
      <div class="iframe-container">
        <iframe 
          :src="auditRequirementUrl" 
          frameborder="0" 
          width="100%" 
          height="100%"
          allowfullscreen
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="auditRequirementVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import sfxDriverAuditForm from "./components/sfxDriverAuditForm.vue";
import {cityCodeJson} from "@/assets/js/city";

export default {
  name: "driverAudit",
  components: {sfxDriverAuditForm},
  data() {
    let arr = [];
    cityCodeJson.forEach((pre) => {
      if (pre.districts) {
        arr.push(...pre.districts);
      }
    });
    arr.forEach((item) => {
      item.label = item.name;
      item.value = item.citycode;
    });
    return {

      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/driverAndVehicle/audit",
        params: {
          applyStatus: 2,
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {type: "input", field: "name", name: "司机名称", value: ""},
          {type: "input", field: "phone", name: "手机号码", value: ""},
          {type: "input", field: "idCard", name: "身份证号", value: ""},
          {type: "input", field: "licenseNo", name: "车辆号牌", value: ""},
          {
            type: "select",
            field: "receivingCityCode",
            name: "接单城市",
            value: "",
            option: arr,
            clearable: true,
            filterable: true,
          },
        ],
      },
      // 表头
      columns: [
        {prop: "phone", label: "手机号码"},
        {prop: "name", label: "司机姓名"},
        {prop: "idCard", label: "身份证号码"},
        {prop: "licenseNo", label: "车辆号牌"},
        {prop: "useCharacter", label: "车辆使用性质", width: 120},
        {prop: "receivingCity", label: "接单城市"},
        {prop: "created", label: "注册时间", hide: true},
        {prop: "applyTime", label: "认证时间"},
        {prop: "auditTime", label: "审核时间", hide: true},
        {prop: "applyStatus", label: "审核状态"},
        {prop: "refusalReason", label: "拒绝原因"},
      ],
      // 详情弹框
      visible: false,
      auditTitle: "审核详情",
      // 司机审核状态
      status: 2,

      operationType: "view",

      // 选择行数据
      rowData: {},
      // 预览大图列表
      previewList: [],
      // 审核要求弹窗
      auditRequirementVisible: false,
      auditRequirementUrl: '',
    };
  },
  computed: {
    reason() {
      return this.mixinUserInfo.platformType == 3
          ? this.sfxReason
          : this.czReason;
    },
  },
  watch: {
    "auditForm.applyStatus"(val) {
      this.rules.refusalReason[0].required = val == 4;
    },
    "auditForm.refusalReason"(val) {
      this.rules.reasonInput[0].required = val == "其他";
    },
  },
  created() {
    if (this.mixinUserInfo.platformType == 3) {
      this.columns.push({
        prop: "channelName",
        label: "归属渠道",
        minWidth: 120,
      });
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
      this.customOptions.params.applyStatus = this.status;
    }
  },
  methods: {
    cancelAudit() {
      this.visible = false;
      this.$refs.customTable.listFn();
    },
    openUrl() {
      const externalLinks = require('@/assets/json/externalLinks').default
      this.auditRequirementUrl = externalLinks.docs.driverAudit;
      this.auditRequirementVisible = true;
    },
    /**
     * 获取使用性质tag类型
     */
    getUseCharacterType(useCharacter) {
      const item = this.$const.USENATURE.find(v => v.value === useCharacter);
      return item ? item.type : 'info';
    },
    findPreviewIndex(url) {
      return this.previewList.findIndex((item) => item === url);
    },
    /**
     * 顶部审核状态改变
     */
    statusChange() {
      this.customOptions.params.page = 1;
      this.customOptions.params.applyStatus = this.status;
      this.$refs.customTable.listFn();
    },
    // 获取详情
    async getDetailInfo(id) {
      const url = `/api/v1/manage/driverAndVehicle/audit/info/${id}`;
      let {code, data} = await this.$axios.get(url);
      if (code === 1) {
        let imgs = [];
        switch (this.mixinUserInfo.platformType) {
          case 3:
            imgs = [
              "idCardFrontPath",
              "idCardBackPath",
              "driverLicensePath",
              "drivingLicenseFront",
              "vehiclePhoto",
              "compulsoryTrafficInsurance",
              "commercialInsurance",
            ]
            break;
          case 4:
            imgs = [
              "idCardFrontPath",
              "idCardBackPath",
              "driverLicensePath",
              "qualificationsPath",
              "drivingLicenseFront",
              "roadTransportCertificate",
              "vehiclePhoto",
              "compulsoryTrafficInsurance",
              "commercialInsurance",
            ]
            break;
          default:
            imgs = [
              "idCardFrontPath",
              "idCardBackPath",
              "driverLicensePath",
              "drivingLicenseFront",
              "vehiclePhoto",
            ]
            break;
        }

        const times = [
          "applyTime",
          "firstIssueDate",
          "registerDate",
          "driverLicenceValid",
        ];
        this.visible = true;
        this.rowData = {
          ...data,
          age: this.$utils.getAgeByIdCard(data.idCard),
          vehicleSeat: data.vehicleSeat,
        };
        this.previewList = [];
      }
    },
    /**
     * 列表操作-查看
     */
    async viewClick(row) {
      this.auditTitle = "审核详情";
      this.operationType = "view";
      this.getDetailInfo(row.id);
    },
    /**
     * 列表操作-审核
     */
    passClick(row) {
      this.auditTitle = "车主认证信息";
      this.operationType = "audit";
      this.getDetailInfo(row.id);
    },

    /**
     * 列表操作-删除
     */
    async removeClick(id) {
      let url = "/api/v1/manage/driverAndVehicle/audit";
      let params = {
        id,
      };
      let data = await this.$axios.delete(url, params);
      if (data && data.code === 1) {
        this.$message.success("删除成功");
        this.$refs.customTable.listFn();
      }
    },


  },
};
</script>

<style lang="less">
#driverAudit {

  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 10px;

    .el-select {
      width: 100%;

      .el-input {
        width: 100%;
      }
    }
  }

  .el-dialog__footer {
    text-align: left;
  }

  // 审核要求弹窗样式
  .audit-requirement-dialog {
    .el-dialog__body {
      padding: 0;
      height: 75vh;
    }
    
    .iframe-container {
      width: 100%;
      height: 100%;
      
      iframe {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }
}
</style>
